import React from 'react';
import { IconCurrencyDollar } from '@tabler/icons-react';

/**
 * Dollar sign icon (20×20) from Figma.
 * @param {{ active?: boolean }} props
 *   active = true  → filled #2F54A5 (default)
 *   active = false → filled #C4C4C4 (gray, inactive)
 */
const DollarIcon = ({ active = true, ...rest }) => (
  <IconCurrencyDollar size={20} color={active ? '#2F54A5' : '#C4C4C4'} style={{ aspectRatio: '1/1' }} {...rest} />
);

export default DollarIcon;
